<template>
  <div class="ace__container">
    <div class="editor"></div>
  </div>
</template>

<script>
  import ace from 'ace-builds'
  import 'ace-builds/src-noconflict/mode-html'
  import 'ace-builds/src-noconflict/theme-monokai'


  export default {
    // eslint-disable-next-line vue/multi-word-component-names
    name: 'Ace',
    props: {
      theme: {
        type: String,
        default: 'monokai',
      },
      lang: {
        type: String,
        required: true
      },
      containerClass: {
        type: String,
        default: ''
      }
    },
    data () {
      return {
        editor: null
      }
    },
    mounted () {
      this.editor = ace.edit(this.$el.querySelector('.editor'))
      this.$emit('init', this.editor)

      this.editor.$blockScrolling = Infinity
      this.editor.getSession().setMode('ace/mode/'+this.lang)
      this.editor.setTheme('ace/theme/'+this.theme)
      // this.editor.resize()

      this.editor.on('change', () => {
        this.$emit('change', this.editor.getValue())
      })
    },
    methods: {
      setValue (value = '') {
        return this.editor.setValue(value, 1)
      }
    }
  }
</script>

<style lang="scss">
  .ace__container {
    width: 100%;
    height: 300px;
    position: relative;

    .editor {
      top: 0;
      right: 0;
      bottom: 0;
      left: 0;
      position: absolute;
      width: 100%;
      height: 300px;
    }
  }
</style>
